import axios from "axios";
import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  SCOOTER_ERROR,
  SCOOTER_LOADING,

  SCOOTER_FILTERS,
  SCOOTER_LIST,
  SCOOTER_CREATE,
  SCOOTER_DELETE,

  SCOOTER_ACTION_LOCK,
  SCOOTER_ACTION_UNLOCK,
  SCOOTER_ACTION_VOICE,
  SCOOTER_ACTION_OPEN_COVER,
  SCOOTER_ACTION_UPDATE_STATUS,
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/scooter";

export const setLoading = (status) => ({
  type: SCOOTER_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, scooterUrl)
    .then((response) => {
      dispatch({
        type: SCOOTER_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then((response) => {
      dispatch({
        type: SCOOTER_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const getQR = (id, callback) => {
  const criteria = [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }];
  requestCommonSearch(ENDPOINT, 0, 1, "id,ASC", criteria, scooterUrl)
    .then((response) => {
      const scooterQR = response && response.content && response.content[0]
        ? response.content[0].qr
        : false;
      callback(scooterQR);
    })
    .catch(() => {
      callback(false);
    });
};

export const getItem = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, null, 1, null, [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }], scooterUrl)
    .then(response => {
      const item = response && response.content && response.content[0]
        ? response.content[0]
        : {};
      callback(item);
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const createItem = (item) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}/${ENDPOINT}`, item)
    .then(() => {
      dispatch({
        type: SCOOTER_CREATE,
        payload: item
      });
      toast("Scooter updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const deleteItem = id => dispatch => {
  dispatch(setLoading(true));
  axios.delete(`${scooterUrl}/${ENDPOINT}/${id}`, id)
    .then(() => {
      dispatch({
        type: SCOOTER_DELETE,
        payload: id
      });
      toast("Scooter deleted successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const actionLock = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}/${id}/lock`)
    .then(() => {
      dispatch({
        type: SCOOTER_ACTION_LOCK,
        payload: id
      });
      if (callback) callback(id);
      toast("Scooter locked successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const actionUnLock = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}/${id}/unlock`)
    .then(() => {
      dispatch({
        type: SCOOTER_ACTION_UNLOCK,
        payload: id
      });
      if (callback) callback(id);
      toast("Scooter unlocked successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const actionVoice = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}/${id}/voice`)
    .then(() => {
      dispatch({
        type: SCOOTER_ACTION_VOICE,
        payload: id
      });
      if (callback) callback(id);
      toast("Scooter voiced successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const actionOpenBatteryCover = (id, callback = false) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}/${id}/open-battery-cover`)
    .then(() => {
      dispatch({
        type: SCOOTER_ACTION_OPEN_COVER,
        payload: id
      });
      if (callback) callback(id);
      toast("Scooter batter cover opened successfully", {
        type: toast.TYPE.SUCCESS
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};

export const actionUpdateScooterStatus = (id, status) => dispatch => {
  dispatch(setLoading(true));
  axios.patch(`${scooterUrl}${ENDPOINT}/${id}/${status}`)
    .then(() => {
      dispatch({
        type: SCOOTER_ACTION_UPDATE_STATUS,
        payload: {
          id,
          status
        }
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/scooter/actions.js